var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeafSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.845 511.845",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B3954"
    },
    d: "M503.141,8.696c-0.016,0-215.215-56.483-390.225,118.511 C-31.579,271.711,96.155,415.69,96.155,415.69s143.979,127.742,288.476-16.775C559.64,223.928,503.156,8.728,503.141,8.696z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M503.141,8.696l-21.337-4.108c0.016,0.031,56.499,219.339-118.495,394.326 c-48.172,48.203-96.299,66.104-139.052,68.572c47.705,2.75,104-12.184,160.374-68.572C559.64,223.928,503.156,8.728,503.141,8.696z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AC054"
    },
    d: "M300.125,211.728c-4.154-4.17-10.918-4.17-15.074,0L3.122,493.635c-4.163,4.186-4.163,10.934,0,15.09 c4.163,4.154,10.911,4.154,15.081,0l281.922-281.923C304.295,222.631,304.295,215.883,300.125,211.728z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafSvg);
export default __webpack_public_path__ + "static/media/LeafSVG.0417943b65e80e89dd7fa581c16efb1f.svg";
export { ForwardRef as ReactComponent };